export default "__VITE_ASSET__9Niwpu0t__"